export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20sourcing%20flat%20lay%20with%20diverse%20curated%20fashion%20items%20including%20premium%20sneakers%20knitwear%20leather%20accessories%20and%20folded%20clothing%20artistically%20arranged%20on%20warm%20textured%20linen%20fabric%20surface%2C%20soft%20golden%20hour%20sunlight%20from%20upper%20left%20creating%20gentle%20highlights%20and%20extended%20shadows%2C%20organic%20composition%20with%20natural%20eucalyptus%20foliage%20accents%2C%20editorial%20fashion%20product%20photography%2C%20warm%20terracotta%20and%20cream%20tones%2C%20high%20detail%2C%20harmonious%20elevated%20aesthetic&width=1600&height=900&seq=hero-mulebuy-v2-2026&orientation=landscape"
          alt="Mulebuy Spreadsheet product sourcing system - curated fashion and lifestyle products"
          title="Mulebuy Spreadsheet Product Sourcing System"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl">
          <p className="text-background-50/80 text-sm md:text-base font-medium tracking-wider uppercase mb-3 md:mb-4">
            The Ultimate Product Sourcing System
          </p>
          <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4 md:mb-6">
            Mulebuy Spreadsheet
            <br />
            <span className="font-light italic text-background-50/90">
              Smarter Sourcing for 2026
            </span>
          </h1>
          <p className="text-background-50/80 text-sm md:text-lg max-w-xl leading-relaxed mb-6 md:mb-8">
            Discover how the Mulebuy Spreadsheet system simplifies global product sourcing,
            compares trusted agents, and helps you find the best deals from China suppliers
            — all in one organized spreadsheet format.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 text-base font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Access Mulebuy Spreadsheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/90 text-foreground-900 hover:bg-background-50 text-base font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              View Latest Product List
              <i className="ri-shopping-bag-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}